import '@collectivehealth/dls-link';
import '@collectivehealth/dls-logos/dist/elements/dls-logo-lockup-tagline.js';
import { StyleUtilities } from '@collectivehealth/dls-styles';

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

function noop() {}

function run(fn) {
  return fn();
}

function blank_object() {
  return Object.create(null);
}

function run_all(fns) {
  fns.forEach(run);
}

function is_function(thing) {
  return typeof thing === 'function';
}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
}

function append(target, node) {
  target.appendChild(node);
}

function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}

function detach(node) {
  node.parentNode.removeChild(node);
}

function element(name) {
  return document.createElement(name);
}

function text(data) {
  return document.createTextNode(data);
}

function space() {
  return text(' ');
}

function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}

function set_custom_element_data(node, prop, value) {
  if (prop in node) {
    node[prop] = value;
  } else {
    attr(node, prop, value);
  }
}

function children(element) {
  return Array.from(element.childNodes);
}

var current_component;

function set_current_component(component) {
  current_component = component;
}

var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;

function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}

function add_render_callback(fn) {
  render_callbacks.push(fn);
}

function flush() {
  var seen_callbacks = new Set();

  do {
    // first, call beforeUpdate functions
    // and update components
    while (dirty_components.length) {
      var component = dirty_components.shift();
      set_current_component(component);
      update(component.$$);
    }

    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    } // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...


    for (var i = 0; i < render_callbacks.length; i += 1) {
      var callback = render_callbacks[i];

      if (!seen_callbacks.has(callback)) {
        callback(); // ...so guard against infinite loops

        seen_callbacks.add(callback);
      }
    }

    render_callbacks.length = 0;
  } while (dirty_components.length);

  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }

  update_scheduled = false;
}

function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    var dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}

var outroing = new Set();

function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}

function mount_component(component, target, anchor) {
  var _component$$$ = component.$$,
      fragment = _component$$$.fragment,
      on_mount = _component$$$.on_mount,
      on_destroy = _component$$$.on_destroy,
      after_update = _component$$$.after_update;
  fragment && fragment.m(target, anchor); // onMount happens before the initial afterUpdate

  add_render_callback(function () {
    var new_on_destroy = on_mount.map(run).filter(is_function);

    if (on_destroy) {
      on_destroy.push.apply(on_destroy, _toConsumableArray(new_on_destroy));
    } else {
      // Edge case - component was destroyed immediately,
      // most likely as a result of a binding initialising
      run_all(new_on_destroy);
    }

    component.$$.on_mount = [];
  });
  after_update.forEach(add_render_callback);
}

function destroy_component(component, detaching) {
  var $$ = component.$$;

  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching); // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)

    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}

function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }

  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}

function init(component, options, instance, create_fragment, not_equal, props) {
  var dirty = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [-1];
  var parent_component = current_component;
  set_current_component(component);
  var prop_values = options.props || {};
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    before_update: [],
    after_update: [],
    context: new Map(parent_component ? parent_component.$$.context : []),
    // everything else
    callbacks: blank_object(),
    dirty: dirty
  };
  var ready = false;
  $$.ctx = instance ? instance(component, prop_values, function (i, ret) {
    var value = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : ret;

    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if ($$.bound[i]) $$.bound[i](value);
      if (ready) make_dirty(component, i);
    }

    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update); // `false` as a special case of no DOM component

  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;

  if (options.target) {
    if (options.hydrate) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.l(children(options.target));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }

    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor);
    flush();
  }

  set_current_component(parent_component);
}

var SvelteElement;

if (typeof HTMLElement === 'function') {
  SvelteElement =
  /*#__PURE__*/
  function (_CustomElement2) {
    _inherits(SvelteElement, _CustomElement2);

    var _super = _createSuper(SvelteElement);

    function SvelteElement() {
      var _this;

      _classCallCheck(this, SvelteElement);

      _this = _super.call(this);

      _this.attachShadow({
        mode: 'open'
      });

      return _this;
    }

    _createClass(SvelteElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        // @ts-ignore todo: improve typings
        for (var key in this.$$.slotted) {
          // @ts-ignore todo: improve typings
          this.appendChild(this.$$.slotted[key]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(attr, _oldValue, newValue) {
        this[attr] = newValue;
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        destroy_component(this, 1);
        this.$destroy = noop;
      }
    }, {
      key: "$on",
      value: function $on(type, callback) {
        // TODO should this delegate to addEventListener?
        var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return function () {
          var index = callbacks.indexOf(callback);
          if (index !== -1) callbacks.splice(index, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set() {// overridden by instance, if it has props
      }
    }]);

    return SvelteElement;
  }(_CustomElement);
}

var footer = {
  "dls-typography-desktop-body-reg-medium": "mcb9eb7dbc_dls-typography-desktop-body-reg-medium",
  "footer": "mcb9eb7dbc_dls-typography-desktop-body-reg-medium mcb9eb7dbc_footer",
  "copyright": "mcb9eb7dbc_copyright",
  "link": "mcb9eb7dbc_link",
  "leftCell": "mcb9eb7dbc_leftCell",
  "rightCell": "mcb9eb7dbc_rightCell"
};
var footer$1 = "mcb9eb7dbc_dls-typography-desktop-body-reg-medium mcb9eb7dbc_footer";
var copyright = "mcb9eb7dbc_copyright";
var link = "mcb9eb7dbc_link";
var leftCell = "mcb9eb7dbc_leftCell";
var rightCell = "mcb9eb7dbc_rightCell";
var styles = ".mcb9eb7dbc_dls-typography-desktop-body-reg-medium{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}[data-style]{display:none}.mcb9eb7dbc_footer{padding-bottom:48px;display:grid;grid-template-columns:repeat(2,1fr)}.mcb9eb7dbc_copyright{margin:0 0 12px}.mcb9eb7dbc_link{border-right:1px solid #999;display:inline-block;margin-right:12px;padding-right:8px}.mcb9eb7dbc_link:last-of-type{border:none;margin-right:0}@media screen and (min-width:0) and (max-width:480px),screen and (min-width:481px) and (max-width:767px),screen and (min-width:768px) and (max-width:1023px),screen and (min-width:1024px) and (max-width:1279px){.mcb9eb7dbc_leftCell{grid-column:1}.mcb9eb7dbc_rightCell{grid-column:1}}@media screen and (min-width:1280px) and (max-width:1439px),screen and (min-width:1440px) and (max-width:1823px),screen and (min-width:1824px){.mcb9eb7dbc_leftCell{grid-column:1}.mcb9eb7dbc_rightCell{grid-column:2;margin-left:auto}}";
var footerStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': footer,
  footer: footer$1,
  copyright: copyright,
  link: link,
  leftCell: leftCell,
  rightCell: rightCell,
  styles: styles
});

function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function create_fragment(ctx) {
  var div3;
  var div1;
  var div0;
  var t0;
  var p;
  var t1;
  var t2_value = new Date().getFullYear() + "";
  var t2;
  var t3;
  var p_class_value;
  var t4;
  var dls_link0;
  var t5;
  var dls_link0_class_value;
  var dls_link0_href_value;
  var t6;
  var dls_link1;
  var t7;
  var dls_link1_class_value;
  var dls_link1_href_value;
  var t8;
  var dls_link2;
  var t9;
  var dls_link2_class_value;
  var dls_link2_href_value;
  var t10;
  var dls_link3;
  var t11;
  var dls_link3_class_value;
  var div1_class_value;
  var t12;
  var div2;
  var dls_logo_lockup_tagline;
  var div2_class_value;
  var div3_class_value;
  return {
    c: function c() {
      div3 = element("div");
      div1 = element("div");
      div0 = element("div");
      t0 = space();
      p = element("p");
      t1 = text("© ");
      t2 = text(t2_value);
      t3 = text(" Collective Health. All rights reserved.");
      t4 = space();
      dls_link0 = element("dls-link");
      t5 = text("Terms");
      t6 = space();
      dls_link1 = element("dls-link");
      t7 = text("Privacy");
      t8 = space();
      dls_link2 = element("dls-link");
      t9 = text("Accessibility");
      t10 = space();
      dls_link3 = element("dls-link");
      t11 = text("Understanding your data");
      t12 = space();
      div2 = element("div");
      dls_logo_lockup_tagline = element("dls-logo-lockup-tagline");
      this.c = noop;
      attr(div0, "data-style", "");
      attr(p, "class", p_class_value =
      /*style*/
      ctx[1].is("copyright"));
      set_custom_element_data(dls_link0, "class", dls_link0_class_value =
      /*style*/
      ctx[1].is("link"));
      set_custom_element_data(dls_link0, "href", dls_link0_href_value = "//" +
      /*memberHost*/
      ctx[2] + "/terms");
      set_custom_element_data(dls_link0, "target", "_blank");
      set_custom_element_data(dls_link1, "class", dls_link1_class_value =
      /*style*/
      ctx[1].is("link"));
      set_custom_element_data(dls_link1, "href", dls_link1_href_value = "//" +
      /*memberHost*/
      ctx[2] + "/privacy");
      set_custom_element_data(dls_link1, "target", "_blank");
      set_custom_element_data(dls_link2, "class", dls_link2_class_value =
      /*style*/
      ctx[1].is("link"));
      set_custom_element_data(dls_link2, "href", dls_link2_href_value = "//" +
      /*memberHost*/
      ctx[2] + "/accessibility");
      set_custom_element_data(dls_link2, "target", "_blank");
      set_custom_element_data(dls_link3, "class", dls_link3_class_value =
      /*style*/
      ctx[1].is("link"));
      set_custom_element_data(dls_link3, "href", "/about");
      set_custom_element_data(dls_link3, "target", "_blank");
      attr(div1, "class", div1_class_value =
      /*style*/
      ctx[1].is("leftCell"));
      attr(div2, "class", div2_class_value =
      /*style*/
      ctx[1].is("rightCell"));
      attr(div3, "class", div3_class_value =
      /*style*/
      ctx[1].is("footer"));
    },
    m: function m(target, anchor) {
      insert(target, div3, anchor);
      append(div3, div1);
      append(div1, div0);
      div0.innerHTML =
      /*stylesheet*/
      ctx[0];
      append(div1, t0);
      append(div1, p);
      append(p, t1);
      append(p, t2);
      append(p, t3);
      append(div1, t4);
      append(div1, dls_link0);
      append(dls_link0, t5);
      append(div1, t6);
      append(div1, dls_link1);
      append(dls_link1, t7);
      append(div1, t8);
      append(div1, dls_link2);
      append(dls_link2, t9);
      append(div1, t10);
      append(div1, dls_link3);
      append(dls_link3, t11);
      append(div3, t12);
      append(div3, div2);
      append(div2, dls_logo_lockup_tagline);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div3);
    }
  };
}

function instance($$self) {
  var stylesheet = "<style>".concat(styles, "</style>");
  var style = new StyleUtilities(footerStyles);
  var hostParts = window.location.host.split(".");
  hostParts[0] = hostParts[0] ? hostParts[0] : "my";
  var memberHost = hostParts.join(".");
  return [stylesheet, style, memberHost];
}

var EpFooter =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(EpFooter, _SvelteElement);

  var _super = _createSuper$1(EpFooter);

  function EpFooter(options) {
    var _this;

    _classCallCheck(this, EpFooter);

    _this = _super.call(this);
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance, create_fragment, safe_not_equal, {});

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }
    }

    return _this;
  }

  return _createClass(EpFooter);
}(SvelteElement); // TODO: don't call by default later, will be breaking change


try {
  window.customElements.define('ep-footer', EpFooter);
} catch (error) {// TODO: See https://github.com/collectivehealth/dls/issues/552
}

export default EpFooter;
export { EpFooter };